import RoleInVesselList from '@/components/roleinvessel/List'
import RoleInVesselCreate from '@/components/roleinvessel/Create'
import RoleInVesselUpdate from '@/components/roleinvessel/Update'
import RoleInVesselShow from '@/components/roleinvessel/Show'

export default [
  {
    name: 'RoleInVesselList',
    path: '/role_in_vessels/',
    component: RoleInVesselList
  },
  {
    name: 'RoleInVesselCreate',
    path: '/role_in_vessels/create',
    component: RoleInVesselCreate
  },
  {
    name: 'RoleInVesselUpdate',
    path: '/role_in_vessels/edit/:id',
    component: RoleInVesselUpdate
  },
  {
    name: 'RoleInVesselShow',
    path: '/role_in_vessels/show/:id',
    component: RoleInVesselShow
  }
]
